export const female_clothes = [ //An array of each Shirt's ID, Atlas file, name, and Hem (if available).
  {
    id: 'outfit72',
    atlas: 'atlas10',
    name: 'Advanced BoS uniform'
  },






  {
    id: 'outfit57', //For shirts or pants, append _frontarm_lowerhalf, _frontarm_upperhalf, _chest, _backarm_lowerhalf, _backarm_upperhalf to find id of each div. 
                   //For pants, append _frontleg_upperhalf, _frontleg_lowerhalf, _frontleg_foot, _crotch, _backleg_upperhalf, _backleg_lowerhalf, _backleg_foot to find id of each class.
                   //For hats, append ??
    atlas: 'atlas09', //Append to atlas to find class.
    name: 'Battle armor' //Show name in textbox.
  },
  {
    id: 'outfit58',
    atlas: 'atlas09',
    name: 'Bittercup\'s outfit'
  },
  {
    id: 'outfit60',
    atlas: 'atlas09',
    name: 'Baseball uniform'
  },



  {
    id: 'outfit65',
    atlas: 'atlas10',
    name: 'Vault socialite',
    skirt: 1
  },
  {
    id: 'outfit66',
    atlas: 'atlas10',
    name: 'Rural schoolmarm',
    skirt: 1
  },
  {
    id: 'outfit67',
    atlas: 'atlas10',
    name: 'Combat armor'
  },
  {
    id: 'outfit68',
    atlas: 'atlas10',
    name: 'Polka dot sundress',
    skirt: 1
  },
  {
    id: 'outfit69',
    atlas: 'atlas10',
    name: 'Expert BoS uniform'
  },
  {
    id: 'outfit70',
    atlas: 'atlas10',
    name: '???',
    skirt: 1
  },
  {
    id: 'outfit71',
    atlas: 'atlas10',
    name: 'BoS uniform'
  },




  
  {
    id: 'outfit73',
    atlas: 'atlas11',
    name: 'Agent provocateur',
    skirt: 1
  },
  {
    id: 'outfit74',
    atlas: 'atlas11',
    name: 'Elf outfit',
    skirt: 1
  },
  {
    id: 'outfit75',
    atlas: 'atlas11',
    name: 'Waitress uniform',
    skirt: 1
  },
  {
    id: 'outfit76',
    atlas: 'atlas11',
    name: 'Movie fan outfit',
    skirt: 1
  },
  {
    id: 'outfit77',
    atlas: 'atlas11',
    name: 'Soda fountain dress',
    skirt: 1
  },
  {
    id: 'outfit78',
    atlas: 'atlas11',
    name: 'Swing dress',
    skirt: 1
  },
  {
    id: 'outfit79',
    atlas: 'atlas11',
    name: 'Country girl'
  },
  {
    id: 'outfit80',
    atlas: 'atlas11',
    name: 'Motorcycle jacket'
  }


  // ,
  // {
  //   id: 'outfit81',
  //   atlas: 'atlas12',
  //   name: 'Wasteland gear'
  // },
  // {
  //   id: 'outfit82',
  //   atlas: 'atlas12',
  //   name: 'Institute jumper'
  // },
  // {
  //   id: 'outfit83',
  //   atlas: 'atlas12',
  //   name: 'Ghost costume',
  //   skirt: 1
  // },
  // {
  //   id: 'outfit84',
  //   atlas: 'atlas12',
  //   name: 'Handyman jumpsuit'
  // },
  // {
  //   id: 'outfit85',
  //   atlas: 'atlas12',
  //   name: 'Flight suit'
  // },
  // {
  //   id: 'outfit86',
  //   atlas: 'atlas12',
  //   name: '???',
  //   skirt: 1
  // },
  // {
  //   id: 'outfit87',
  //   atlas: 'atlas12',
  //   name: 'Republic robes',
  //   skirt: 1
  // },
  // {
  //   id: 'outfit88',
  //   atlas: 'atlas12',
  //   name: 'Radiation suit',
  //   hem: 1
  // }




  // ,
  // {
  //   id: 'outfit89',
  //   atlas: 'atlas13',
  //   name: 'Pilgrim outfit',
  //   skirt: 1
  // },
  // {
  //   id: 'outfit90',
  //   atlas: 'atlas13',
  //   name: 'Piper\'s outfit',
  //   hem: 1
  // },
  // {
  //   id: 'outfit91',
  //   atlas: 'atlas13',
  //   name: 'Military fatigues'
  // },
  // {
  //   id: 'outfit92',
  //   atlas: 'atlas13',
  //   name: 'Nightwear'
  // },
  // {
  //   id: 'outfit93',
  //   atlas: 'atlas13',
  //   name: 'Lifeguard outfit'
  // },
  // {
  //   id: 'outfit94',
  //   atlas: 'atlas13',
  //   name: 'Metal armor'
  // },
  // {
  //   id: 'outfit95',
  //   atlas: 'atlas13',
  //   name: 'Vault suit'
  // },
  // {
  //   id: 'outfit96',
  //   atlas: 'atlas13',
  //   name: 'Lab coat',
  //   hem: 1
  // }



  // ,
  // {
  //   id: 'outfit97',
  //   atlas: 'atlas14',
  //   name: 'Merc gear',
  //   hem: 1
  // },
  // {
  //   id: 'outfit98',
  //   atlas: 'atlas14',
  //   name: 'Santa suit',
  //   skirt: 1
  // },
  // {
  //   id: 'outfit99',
  //   atlas: 'atlas14',
  //   name: 'Maternity clothes'
  // },
  // {
  //   id: 'outfit100',
  //   atlas: 'atlas14',
  //   name: 'Raider armor'
  // },
  // {
  //   id: 'outfit101',
  //   atlas: 'atlas14',
  //   name: 'T-60 power armor'
  // },
  // {
  //   id: 'outfit102',
  //   atlas: 'atlas14',
  //   name: 'X-01 Mk VI power armor'
  // },
  // {
  //   id: 'outfit103',
  //   atlas: 'atlas14',
  //   name: 'T-45 power armor'
  // },
  // {
  //   id: 'outfit104',
  //   atlas: 'atlas14',
  //   name: 'T-51 power armor'
  // }



  // ,
  // {
  //   id: 'outfit105',
  //   atlas: 'atlas15',
  //   name: 'Treasure hunter gear',
  //   hem: 1
  // },
  // {
  //   id: 'outfit106',
  //   atlas: 'atlas15',
  //   name: 'Armored vault suit'
  // },
  // {
  //   id: 'outfit107',
  //   atlas: 'atlas15',
  //   name: 'Swimsuit'
  // },
  // {
  //   id: 'outfit108',
  //   atlas: 'atlas15',
  //   name: 'Synth armor'
  // },
  // {
  //   id: 'outfit109',
  //   atlas: 'atlas15',
  //   name: 'Skeleton costume'
  // },
  // {
  //   id: 'outfit110',
  //   atlas: 'atlas15',
  //   name: 'Wasteland medic'
  // },
  // {
  //   id: 'outfit111',
  //   atlas: 'atlas15',
  //   name: 'Junior officer uniform'
  // },
  // {
  //   id: 'outfit112',
  //   atlas: 'atlas15',
  //   name: 'Initiate robe',
  //   hem: 1
  // },
  // {
  //   id: 'outfit113',
  //   atlas: 'atlas16',
  //   name: 'Leather armor',
  //   hem: 1
  // }
]